import request from "@/api";

export interface EnterpriseRow {
    supplier?: {
        id?: number | string;
        code?: string;
        supplierName?: string;
        type?: number | string;
        groupCompanyName?: string;
        legalRepresentative?: string;
        socialCreditCode?: string;
        province?: string;
        city?: string;
        region?: string;
        address?: string;
        provinceCode?: string;
        cityCode?: string;
        regionCode?: string;
        showLocation?: number | string;
        contactPerson?: string;
        contactPhone?: string;
        mainCategories?: string;
        description?: string;
        logoFileId?: number | string;
        businessFileId?: number | string;
        mobileSideFileId?: number | string;
        pcSideFileId?: number | string;
        labels?: string[];
        createdTime?: string;
    };
    productConsignment?: unknown[];
}

export interface EnterprisePageResult {
    list?: EnterpriseRow[];
    total?: number;
}

export interface EnterpriseQuery {
    page: number;
    size: number;
    supplierName?: string;
    type?: number[];
    groupCompanyId?: number;
    sortKey?: string;
    sortOrder?: string;
}

/** 适配旧 Vue 企业管理分页接口，保留原路径与查询字段。 */
export async function loadEnterprisePage(query: EnterpriseQuery): Promise<EnterprisePageResult> {
    const { data } = await request.service.get<EnterprisePageResult>("/admin/supplier-admin/paging", { params: query });
    return data;
}

/** 适配旧 Vue 企业管理详情接口，详情编号仍使用路径参数。 */
export async function loadEnterpriseDetail(id: string): Promise<EnterpriseRow> {
    const { data } = await request.service.get<EnterpriseRow>(`/admin/supplier-admin/find/${id}`);
    return data;
}

/** 复用旧 Vue 企业管理删除接口，保持列表操作与供应商管理一致。 */
export async function deleteEnterprisePage(id: number | string): Promise<unknown> {
    const { data } = await request.service.delete(`/admin/supplier-admin/delete/${id}`);
    return data;
}
